const comments = [
  {
    name: '追剧小达人',
    time: '3天前',
    rating: 5,
    content: '用了半年多了，91影视看片app真的是我用过最好的免费追剧平台。更新速度很快，热播剧上线当天就能看，画质清晰还不卡，推荐给身边好多朋友了！',
  },
  {
    name: '电影爱好者阿杰',
    time: '5天前',
    rating: 5,
    content: '资源太全了！想看的院线大片基本都能找到高清版，不用再到处找资源了。播放流畅度也很棒，用4G看都不怎么缓冲，必须好评。',
  },
  {
    name: '深夜追剧人',
    time: '1周前',
    rating: 5,
    content: '没有广告这点真的太良心了。以前用其他平台看个剧中间弹好几次广告，这里全程无打扰。画质清晰度也高，追剧体验满分。',
  },
  {
    name: '综艺铁粉小雪',
    time: '1周前',
    rating: 4,
    content: '综艺节目更新很及时，周末必看的几档综艺都能在这里找到高清完整版。希望后续能增加更多海外综艺资源，那就更完美了。',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">影友热评</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">来自真实用户的使用评价与追剧体验</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {comments.map((c, i) => (
            <div key={i} className="p-6 rounded-2xl bg-background-50 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-sm font-bold">
                  {c.name.charAt(0)}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-bold text-foreground-900 whitespace-nowrap">{c.name}</p>
                  <p className="text-xs text-foreground-400">{c.time}</p>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: c.rating }).map((_, j) => (
                    <i key={j} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                  {c.rating < 5 && (
                    <i className="ri-star-line text-foreground-300 text-sm"></i>
                  )}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}